import React from 'react';
import { isClassComponent } from 'recompose';
import PolarisContext from './PolarisContext';

/**
 * Higher Order Component which wraps the consumer context on the wrapped component.
 * @param {*} WrappedComponent - whatever the component we wrap with withPolaris.
 */
const withPolaris = (BaseComponent) => {
  if (isClassComponent(BaseComponent)) {
    class wrappedComponent extends BaseComponent {
      render() {
        return (
          <PolarisContext.Consumer>
            {context => <BaseComponent {...this.props} context={context} />}
          </PolarisContext.Consumer>
        );
      }
    }

    return wrappedComponent;
  }

  const wrappedComponent = props => (
    <PolarisContext.Consumer>
      {context => <BaseComponent {...props} context={context} />}
    </PolarisContext.Consumer>
  );

  return wrappedComponent;
};

export default withPolaris;
